module.exports = __webpack_public_path__ + "media/widget/ActiveGoals-92b584f3.png";